// Helpers WebAuthn (passkeys). El navegador exige ArrayBuffer, el backend base64url.
// Ver backend: routes/passkeys.py

const b64uToBuf = (v) => {
  const b64 = v.replace(/-/g, '+').replace(/_/g, '/');
  const pad = b64.length % 4 ? '='.repeat(4 - (b64.length % 4)) : '';
  const raw = atob(b64 + pad);
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
};

const bufToB64u = (buf) => {
  const bytes = new Uint8Array(buf);
  let s = '';
  bytes.forEach((b) => { s += String.fromCharCode(b); });
  return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

export const passkeysSoportadas = () =>
  typeof window !== 'undefined' && !!window.PublicKeyCredential;

/** Ejecuta la ceremonia de REGISTRO y devuelve la credencial serializada. */
export const crearPasskey = async (options) => {
  const publicKey = {
    ...options,
    challenge: b64uToBuf(options.challenge),
    user: { ...options.user, id: b64uToBuf(options.user.id) },
    excludeCredentials: (options.excludeCredentials || []).map((c) => ({
      ...c, id: b64uToBuf(c.id),
    })),
  };
  const cred = await navigator.credentials.create({ publicKey });
  return {
    id: cred.id,
    rawId: bufToB64u(cred.rawId),
    type: cred.type,
    transports: cred.response.getTransports ? cred.response.getTransports() : [],
    response: {
      clientDataJSON: bufToB64u(cred.response.clientDataJSON),
      attestationObject: bufToB64u(cred.response.attestationObject),
    },
    clientExtensionResults: cred.getClientExtensionResults(),
  };
};

/** Ejecuta la ceremonia de LOGIN y devuelve la aserción serializada. */
export const usarPasskey = async (options) => {
  const publicKey = {
    ...options,
    challenge: b64uToBuf(options.challenge),
    allowCredentials: (options.allowCredentials || []).map((c) => ({
      ...c, id: b64uToBuf(c.id),
    })),
  };
  const cred = await navigator.credentials.get({ publicKey });
  return {
    id: cred.id,
    rawId: bufToB64u(cred.rawId),
    type: cred.type,
    response: {
      clientDataJSON: bufToB64u(cred.response.clientDataJSON),
      authenticatorData: bufToB64u(cred.response.authenticatorData),
      signature: bufToB64u(cred.response.signature),
      userHandle: cred.response.userHandle ? bufToB64u(cred.response.userHandle) : null,
    },
    clientExtensionResults: cred.getClientExtensionResults(),
  };
};

/** Traduce los errores del navegador a algo que se entienda. */
export const errorPasskey = (e) => {
  const n = e?.name || '';
  if (n === 'NotAllowedError') return 'Cancelaste la verificación o se agotó el tiempo';
  if (n === 'InvalidStateError') return 'Este dispositivo ya tiene una passkey registrada';
  if (n === 'SecurityError') return 'El dominio no coincide con el de la passkey';
  if (n === 'NotSupportedError') return 'Este dispositivo no soporta passkeys';
  return e?.message || 'No se pudo completar la verificación';
};
